import { useQuery } from 'react-query';
import { useServices } from '../../../services/useServices';

const TOKEN_TTL_MS = 290 * 1000; // Must match backend TOKEN_TTL_SECONDS exactly
const REFRESH_BUFFER_MS = 30 * 1000; // Refetch 30s before expiry

export const useTableauEmbedToken = () => {
  const {
    book: { getTableauEmbedToken }
  } = useServices();

  const res = useQuery<{ token: string; expires_in: number }>(
    ['tableau-embed-token'],
    () => getTableauEmbedToken(),
    {
      // Token is fresh for (290 - 30) = 260s, then react-query refetches proactively
      staleTime: TOKEN_TTL_MS - REFRESH_BUFFER_MS,
      // Keep in cache for exactly one TTL cycle; after that it's dead
      cacheTime: TOKEN_TTL_MS,
      // Refetch when the window regains focus — catches the "left idle" scenario
      refetchOnWindowFocus: true,
      // Also refetch when component remounts after being unmounted
      refetchOnMount: true,
      retry: (failureCount, error: any) => {
        if (error?.response?.status === 403) {
          return false;
        }
        return failureCount < 1;
      },
      retryDelay: 500
    }
  );

  return {
    token: res.data?.token ?? null,
    isLoading: res.isLoading,
    isFetching: res.isFetching,
    isError: res.isError && !res.isFetching
  };
};